import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuList:[],
    userInfo:{},
  },
  mutations: {
    setMenuList(state, value) {
      state.menuList = value;
    },
    setUserInfo(state,value){
      state.userInfo = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
